import { ReaderOptions } from 'zxing-wasm';

export const BARCODE_DEFAULT_READER_OPTIONS: ReaderOptions = {
    tryHarder: true,
    formats: ['Code128', 'Code39', 'EAN-13', 'ITF', 'QRCode', 'UPC-E', 'DataMatrix'],
    maxNumberOfSymbols: 3,
};

/**
 * The debounce time in milliseconds for refocusing the barcode scanner.
 * This constant is used to prevent the barcode scanner from refocusing too frequently,
 * when users hammer on the button, which can improve performance and reduce unnecessary operations.
 */
export const BARCODE_REFOCUS_DEBOUNCE = 77;

/**
 * The delay in milliseconds between each loop iteration for the barcode scanner.
 * This constant is used to control the frequency of barcode scanning attempts.
 */
export const BARCODE_LOOP_DELAY = 77;

/**
 * The delay in milliseconds when restarting the barcode stream, before starting a new stream.
 */
export const BARCODE_STREAM_RESTART_DELAY = 1234;

/**
 * The cooldown period (in milliseconds) before resetting the height of the ghost container,
 * when restarting the stream. The idea is to prevent the elements on the page from jumping.
 */
export const BARCODE_STREAM_RESTART_COOLDOWN = 77;
